module.exports = __webpack_public_path__ + "static/media/pen1.853de662.png";